import { searchRefinersMoreInfoAriaLabelNext } from './getSearchRefinersButtonStrings.locstring.json';
import isAttachmentsRefinerApplied from './isAttachmentsRefinerApplied';
import isDateRefinerApplied from './isDateRefinerApplied';
import { getStore } from '../store/store';
import getSearchScopeDisplayName from '../utils/getSearchScopeDisplayName';
import { PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID } from 'owa-folders';
import loc, { format } from 'owa-localize';
import { optionTitle_filters } from 'owa-locstrings/lib/strings/optiontitle_filters.locstring.json';
import { refinersLabel } from 'owa-locstrings/lib/strings/refinerslabel.locstring.json';
import { SearchScopeKind } from 'owa-search-service';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { isFeatureEnabled } from 'owa-feature-flags';

export interface SearchRefinersButtonStrings {
    buttonText: string;
    ariaLabel: string;
}

export default function getSearchRefinersButtonStrings(): SearchRefinersButtonStrings {
    const staticSearchScope = getStore().staticSearchScope;

    // If staticSearchScope hasn't been initialized yet, return empty strings.
    if (!staticSearchScope) {
        return {
            buttonText: '',
            ariaLabel: '',
        };
    }

    // Default to generic "Filters" label.
    let searchScopeNameToShow = loc(optionTitle_filters);

    // If the scope isn't "All Folders", then change label to folder name.
    if (
        (staticSearchScope.kind === SearchScopeKind.PrimaryMailbox &&
            folderIdToName(staticSearchScope.folderId) !== PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID) ||
        isFeatureEnabled('sea-filterLabel1') ||
        isFeatureEnabled('sea-filterLabel2')
    ) {
        searchScopeNameToShow = getSearchScopeDisplayName(staticSearchScope);
    }

    let appliedRefinersCount = 0;
    isAttachmentsRefinerApplied() ? appliedRefinersCount++ : null;
    isDateRefinerApplied() ? appliedRefinersCount++ : null;

    /**
     * If there aren't any refiners applied, the button text will just be the folder
     * name. However, if there are refiners applied, show that count alongside
     * the folder name.
     */
    const buttonText =
        appliedRefinersCount === 0
            ? searchScopeNameToShow
            : format(loc(refinersLabel), searchScopeNameToShow, appliedRefinersCount);

    return {
        buttonText: buttonText,
        ariaLabel: format(
            loc(searchRefinersMoreInfoAriaLabelNext),
            searchScopeNameToShow,
            appliedRefinersCount
        ),
    };
}
